import React from 'react';
import { Spin } from 'antd';
import RealBricksLogo from '../../assets/images/RealBricksLogo.png';
import './BranchIoLoader.css';

const BranchIoLoader = () => {
  return (
    <div className="branch-io-loader-overlay">
      <div className="branch-io-loader-box">
        <img
          src={RealBricksLogo}
          alt="RealBricks"
          className="branch-io-loader-logo"
        />
        <Spin size="large" className="branch-io-loader-spin" />
        <span className="branch-io-loader-text">Opening app…</span>
      </div>
    </div>
  );
};

export default BranchIoLoader;
